const getConversationData = (name) => ([
    {
        text: `Hi, I'm ${name}  - your Registered Dietitian. Click a message option to start a chat!`,
        fromRD: true,
    },
    {
        text: "When should I take my protein powder?",
        fromRD: false,
    },
    {
        text: "Most often I suggest to use your protein powder after workouts to help with meeting protein needs and improving recovery. If you don’t already consume a protein source at that time, it’s a great place for it. However, the best time to use protein powder may differ based on where you possibly struggle with your protein intake or eating habits.",
        fromRD: true,
    },
    {
        text: "Can I use my protein powder as a meal replacement?",
        fromRD: false,
    },
    {
        text: "Generally I don’t suggest replacing your meals completely. Your protein powder can be a helpful tool in your diet, but also shouldn’t take up a large portion of it. Some people do benefit from including their protein powder into their meal though if for example it doesn’t contain protein otherwise, or if they are trying to make changes to the meal.",
        fromRD: true,
    },
    {
        text: "How often should I use my protein powder?",
        fromRD: false,
    },
    {
        text: "Typically I recommend using one serving of your protein powder per day. Along with a healthy and balanced diet, this should be sufficient for meeting your protein needs. However for some, more or less may be suggested. It can depend on your protein needs and how much protein you normally consume through the rest of your diet.",
        fromRD: true,
    },
    {
        text: "I have another question",
        fromRD: false,
    },
    {
        text: "Type your question below and I will respond via email! I usually get to all messages within 1-2 business days.",
        fromRD: true,
        showInput: true,
    }
]);
export default getConversationData;
